import { render, staticRenderFns } from "./InsInfoTip.vue?vue&type=template&id=23b27ef4&scoped=true"
import script from "./InsInfoTip.vue?vue&type=script&lang=js"
export * from "./InsInfoTip.vue?vue&type=script&lang=js"
import style0 from "./InsInfoTip.vue?vue&type=style&index=0&id=23b27ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b27ef4",
  null
  
)

export default component.exports